module.exports = __webpack_public_path__ + "img/03.c5e07784.png";